import { render, staticRenderFns } from "./SdsTableSectionAccordionDefault.vue?vue&type=template&id=61f0cb47&scoped=true"
var script = {}
import style0 from "./SdsTableSectionAccordionDefault.vue?vue&type=style&index=0&id=61f0cb47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0cb47",
  null
  
)

export default component.exports